module.exports = __webpack_public_path__ + "static/media/s_1.5a097f80.mp3";